import { jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { StateContainer } from './StateContainer';
import { StyledSummary } from './styles';
export const Summary = ({ children, expandIcon, tabIndex, ...rest }) => {
    const { disabled, isExpanded, onChange: onChangeProp, toggleIsExpanded, } = StateContainer.useContainer();
    const icon = React.useMemo(() => {
        return !expandIcon
            ? null
            : typeof expandIcon === 'function'
                ? expandIcon(isExpanded)
                : expandIcon;
    }, [expandIcon, isExpanded]);
    const onChange = React.useCallback((event) => {
        if (disabled)
            return;
        onChangeProp && onChangeProp(event, !isExpanded);
        toggleIsExpanded();
        event.preventDefault();
    }, [disabled, isExpanded, onChangeProp, toggleIsExpanded]);
    const onClick = React.useCallback((event) => {
        onChange(event);
    }, [onChange]);
    const onKeyDown = React.useCallback((event) => {
        if (['Enter', 'Space'].includes(event.code))
            onChange(event);
    }, [onChange]);
    return (_jsxs(StyledSummary, { onClick, onKeyDown, "aria-expanded": isExpanded, role: 'button', tabIndex: tabIndex ?? 0, ...rest, children: [typeof children === 'function' ? children(isExpanded) : children, icon] }));
};
//# sourceMappingURL=Summary.js.map